var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`kit-status-pill kit-status-${_vm.status}-bg kit-status-${_vm.status}-fc`},[_c('span',{staticClass:"t3 -t_medium"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }